<template>
    <div class="white">
        <div
            v-for = "(entry, index) in menu"
            :key  = "index"
        >
            <a @click = "onMenu(entry)">
                <div style="height: 22px;" class="v-flex">
                    <v-icon
                        size   = "18"
                        :color = "entry.available ? 'black' : 'secondary'"
                    >
                        {{ entry.icon }}
                    </v-icon>

                    <div style="font-size: 13px;padding-left: 4px; margin-top: 2px; width: 100px">
                        {{ entry.name }}
                    </div>

                    <div
                        v-if   = "entry.available"
                        class  = "menu-status"
                    >
                        <v-icon size="20" :color="statusColor (entry.status)">{{ statusIcon (entry.status) }}</v-icon>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import Disposition from "@/modules/dis/service/Disposition";

export default {
    name: "CInspectionScopeCompact",

    props: {
        inspection: {

        }
    },

    data: () => ({
        menu: null
    }),

    computed: {
        areas () {
            return Disposition.inspection.areas;
        }
    },

    mounted() {
        this.initialize();
    },

    watch: {
        inspection () {
            this.initialize();
        }
    },

    methods: {
        initialize () {
            if (!this.inspection) {
                return;
            }

            this.menu = Disposition.inspection.menu(this, this.inspection).filter(m => m.scope);
        },

        onMenu(entry) {
            if (!entry.available) {
                return;
            }

            this.$emit("menu", entry);
        },

        statusColor (status) {
            switch (status) {
                case "CREATED":
                    return null;
                case "IN_PROCESS":
                    return "grey";
                case "PROCESS_DONE":
                    return "grey";
                case "TRANSFER_DONE":
                    return "success"
                default:
                    return "black";
            }
        },

        statusIcon (status) {
            switch (status) {
                case "CREATED":
                    return null;
                case "IN_PROCESS":
                    return "mdi-pencil-box";
                case "PROCESS_DONE":
                    return "mdi-thumb-up";
                case "TRANSFER_DONE":
                    return "mdi-thumb-up"
                default:
                    return null;
            }
        }
    }
}
</script>

<style scoped>

.menu-status {
    margin-top: -2px;
}

::v-deep .v-list-item .v-list-item__subtitle, .v-list-item .v-list-item__title {
    line-height: 2.2;
}

</style>